import React, { useRef , Fragment} from 'react';
import CategoryShortcuts from "plugin/CategoryShortcuts/CategoryShortcuts";
import MediaQuery from "react-responsive"
import {Card, Image, Button} from "semantic-ui-react"
import {Link} from "react-router-dom"
import settingStore from "stores/settingStore";
import {observer} from "mobx-react"
import ImageWithFallback from "components/ImageWithFallback"
import shop from "shop/shop"
import categoryStore     from "stores/categoryStore"

const CategorySlider = observer(({ firstCategory, categoryforCardsLaboratory, categoryforCardsMedicine, className = "", orderMode}) => {
  
  const scrollRef = useRef(null);

  const scroll = (scrollOffset) => {
    scrollRef.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
  };

    let base = "";
    let parents = [];
    console.log("firstCategory", firstCategory)
    if ( firstCategory && firstCategory.getParents ) {
        parents = firstCategory.getParents()
        base = `/collection/${parents.map( id => `${id}/` ).join( "" )}${firstCategory.map_id}/`

    }
    else {
        base = `/collection/`
    }

// Responsive paddingRight based on device width
const isTablet = window.innerWidth < 1200;
const isMobile = window.innerWidth < 768;
const containerPaddingRight = isMobile && isTablet ? "350px" :  isTablet ? "100px" :"-100%";
console.log("Container Padding Right:",isTablet,  isMobile, containerPaddingRight);
return (
<div className="relative w-100 container" style={{ minHeight: "500px", paddingRight: containerPaddingRight }}>
  {/* Navigation Buttons */}
  <div>
    <p className={`f2 fw7 pb5 pt3 bt bw2 w-50`}style={{ minWidth: isMobile ? "400px" : "" }}>
      {  firstCategory && firstCategory.map_id == 40 ?  translate("Produktkategorien Labor") : firstCategory && firstCategory.map_id == 49 ? translate("Produktkategorien Medizin") : translate("Produktkategorien")}
    </p>
  </div>

  <div style={{ minWidth: isMobile ? "300px" : "" }}>
    <Button primary style={{
                  backgroundColor: "transparent",
                  border: "1px solid black",
                    borderRadius: "35px", 
                    height: "50px", 
                    width: "50px", 
                    color: "black",
                    transition: "all 0.3s ease",
                    padding: "10px 20px 10px 20px",
                  }} 
                  onClick={() => scroll(-300)} className="br-100 pa2 bg-white b"
                   >
                    <p className="black">❮</p>
                  </Button>
    <Button primary style={{
                  backgroundColor: "transparent",
                  border: "1px solid black",
                    borderRadius: "35px", 
                    height: "50px", 
                    width: "50px", 
                    color: "black",
                    transition: "all 0.3s ease",
                    padding: "10px 20px 10px 20px",
                  }} 
                  onClick={() => scroll(300)} className="br-100 pa2  bg-white b"
                   >
                   <p className="black">❯</p>
                  </Button>
    </div>

    {/* Wrapper mit negativem Margin, damit der Scrollbereich überläuft */}
    <div className="relative pt4 " style={{ marginLeft: '-3rem', marginRight: '-25rem' }}>
      {/* Scroll Container */}
      <div
        ref={scrollRef}
        className="flex overflow-x-auto ph4 scrollbar-hide hide-scrollbar"
        style={{
          scrollbarWidth: 'none',
          minHeight: "500px",
          scrollBehavior: 'smooth',
          WebkitOverflowScrolling: 'touch',
          paddingLeft: '2rem',
          paddingRight: '2rem',
        }}
      >
        {/* Kacheln */}
        {firstCategory && firstCategory.children.map(category => {
          if(shop.config.plugin && shop.config.plugin.SEOCategoryLink){
            const seoCategory = categoryStore._SEOCategoryTree['/' + parents.map( id => `${id}/` ).join( "" ) + firstCategory.map_id + `/${category.map_id}`];
            base = `/collection/${seoCategory.textpath.substring(1)}`;
            //console.log("SEO Category Tree categoryID", seoCategory,firstCategory.map_id, base, '/' + parents.map( id => `${id}/` ).join( "" ) + firstCategory.map_id + `/${category.map_id}`)
          }
          else{
            base = `/collection/${parents.map( id => `${id}/` ).join( "" )}${category.map_id}/`
          }
          return (
            <Fragment key={category.map_id}>
              <Card
                style={{
            backgroundColor: `white`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minWidth: "300px",
            maxWidth: "300px",
            minHeight: "230px",
            maxHeight: "420px"
                }}
                className={`CategoryCard  ${className}`} as={Link} to={base}
              >
                <ImageWithFallback style={{maxHeight: "200px"}} src={category.img_src} fallback={"/image/Rechteck 851.png"} />
                <div
            className="white pa2 pa3-ns"
            style={{
              backgroundColor: `white`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              minWidth: "500px",
              minHeight: "230px",
              maxHeight: "230px"
            }}
                >
            <p className="black-30 pt3 f5 b pl3">{category.desc.short_des}</p>
            <Link className={"black db pa3 pl3 pt5 mt4 f3 b hover-primary underline-hover transition "} to={base + "/"}>
              {category.desc.short_des}
            </Link>
            <Link
              className={` db pl3 pr3 pb4 f5 b hover-primary color-primary underline-hover transition LinkBackgroundStyle`}
              
              to={base}
            >
              {translate("Produkte ansehen")}
            </Link>
                </div>
              </Card>
            </Fragment>
          );
        })}
      </div>
    </div>
</div>
);
});

export default CategorySlider;


// WEBPACK FOOTER //
// ./src/plugin/CategoryShortcuts/CategorySlider.js